<template>
  <div>
    <div>
      <div class="my-4">
        <h1>
          <span class="mr-3">Welcome Point</span>
          <template v-if="!loading">
            <span v-if="welcomepointstatus_loading">
              <v-progress-circular indeterminate color="primary" size="20"></v-progress-circular>
            </span>
            <toggle-button
              v-else
              :value="welcome_points_status"
              :sync="true"
              :loading="true"
              :color="$vuetify.theme.success"
              :labels="{ checked: 'ON', unchecked: 'OFF' }"
              @change="setWelcomPointStatus"
            />
          </template>
        </h1>
        <div v-if="loading">
          <scale-loader class="my-4" :loading="true" color="grey"></scale-loader>
        </div>
        <v-layout v-else row wrap>
          <v-flex xs6 class="pt-2">
            <div v-if="!isEditWelcomePoint">
              <span class="primary--text" style="font-weight: bold; font-size: 23px">{{
                welcome_points
              }}</span>
              Point
            </div>
            <div v-else>
              <div class="form-control">
                <input v-model="input.welcome_points" type="number" />
              </div>
              <div class="text-xs-center">
                <v-btn
                  :disabled="welcomepointloading"
                  outline
                  color="grey"
                  @click="cancelWelcomePoint"
                  >Cancel</v-btn
                ><v-btn
                  :loading="welcomepointloading"
                  depressed
                  color="primary"
                  @click="saveWelcomePoint"
                  >Save</v-btn
                >
              </div>
            </div>
          </v-flex>
          <v-flex xs6 class="text-xs-right">
            <v-btn
              v-if="!isEditWelcomePoint"
              icon
              @click="
                isEditWelcomePoint = true
                input.welcome_points = welcome_points
              "
            >
              <v-icon>edit</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </div>
      <v-divider></v-divider>
      <div class="my-4">
        <h1>Point</h1>
        <div class="red--text" style="font-size: small">
          * การคิดคะแนนโดยคิดจากยอดซื้อ หารตัวเลขที่ตั้งค่าไว้ด้านล่าง เช่นหาร 100
          และนำไปบวกกับคะแนนจากรายการสินค้า
        </div>
        <div v-if="loading">
          <scale-loader class="my-4" :loading="true" color="grey"></scale-loader>
        </div>
        <v-layout v-else row wrap>
          <v-flex xs6 class="pt-2">
            <div v-if="!isEditDividePoint">
              หารด้วย
              <span class="primary--text" style="font-weight: bold; font-size: 23px">{{
                purchase_amount
              }}</span>
            </div>
            <div v-else>
              <div class="form-control">
                <input v-model="input.purchase_amount" type="number" />
              </div>
              <div class="text-xs-center">
                <v-btn
                  :disabled="purchase_amountloading"
                  outline
                  color="grey"
                  @click="cancelDividePoint"
                  >Cancel</v-btn
                ><v-btn
                  :loading="purchase_amountloading"
                  depressed
                  color="primary"
                  @click="saveDividePoint"
                  >Save</v-btn
                >
              </div>
            </div>
          </v-flex>
          <v-flex xs6 class="text-xs-right">
            <v-btn
              v-if="!isEditDividePoint"
              icon
              @click="
                isEditDividePoint = true
                input.purchase_amount = purchase_amount
              "
            >
              <v-icon>edit</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </div>
      <v-divider></v-divider>
      <div class="my-4">
        <h1>Slip upload expiration</h1>
        <div v-if="loading">
          <scale-loader class="my-4" :loading="true" color="grey"></scale-loader>
        </div>
        <v-layout v-else row wrap>
          <v-flex xs10 class="pt-2">
            <v-layout row wrap justify-space-around align-content-center align-center>
              <v-flex xs12 sm5 class="form-control"
                ><div class="primary--text">วันตัดรอบอัพโหลดslipรอบนี้</div>
              </v-flex>
              <v-flex xs12 sm5 class="form-control"
                ><div class="primary--text">วันตัดรอบอัพโหลดslipรอบหน้า</div>
              </v-flex>
            </v-layout>
            <div v-if="!isEditSlipUploadExpiration">
              <v-layout
                justify-space-around
                align-content-center
                align-center
                row
                wrap
                class="pa-0 ma-0"
              >
                <v-flex xs12 sm5 class="form-control">{{
                  slip_upload_expiration | DateFormat('วันที่ DD/MM/YYYY')
                }}</v-flex>
                <v-flex xs12 sm5 class="form-control">{{
                  slip_upload_expiration_next | DateFormat('วันที่ DD/MM/YYYY')
                }}</v-flex>
              </v-layout>
            </div>
            <div v-else>
              <v-layout
                justify-space-around
                align-content-center
                align-center
                row
                wrap
                class="pa-0 ma-0"
              >
                <v-flex xs12 sm5 class="form-control">
                  <DatepickerCustomDialog v-model="input.slipUploadExpireDate">
                    <input type="text" readonly :value="slipDateFormated" />
                  </DatepickerCustomDialog>
                </v-flex>
                <v-flex xs12 sm5 class="form-control">
                  <DatepickerCustomDialog v-model="input.slipUploadExpireDateNext">
                    <input type="text" readonly :value="slipDateFormatedNext" />
                  </DatepickerCustomDialog>
                </v-flex>
              </v-layout>
              <div class="text-xs-center">
                <v-btn :disabled="expireloading" outline color="grey" @click="cancelExpSlipUpload"
                  >Cancel</v-btn
                ><v-btn
                  :loading="expireloading"
                  depressed
                  color="primary"
                  @click="saveSlipUploadExp"
                  >Save</v-btn
                >
              </div>
            </div>
          </v-flex>
          <v-flex xs2 class="text-xs-right">
            <v-btn v-if="!isEditSlipUploadExpiration" icon @click="editSlipUploadExp">
              <v-icon>edit</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </div>
      <v-divider></v-divider>
      <div class="my-4">
        <h1>Point expiration</h1>
        <div v-if="loading">
          <scale-loader class="my-4" :loading="true" color="grey"></scale-loader>
        </div>
        <v-layout v-else row wrap>
          <v-flex xs10 class="pt-2">
            <v-layout row wrap justify-space-around align-content-center align-center>
              <v-flex xs12 sm5 class="form-control"
                ><div class="primary--text">วันหมดอายุรอบคะแนนครั้งนี้</div>
              </v-flex>
              <v-flex xs12 sm5 class="form-control"
                ><div class="primary--text">วันหมดอายุรอบคะแนนครั้งหน้า</div>
              </v-flex>
            </v-layout>
            <div v-if="!isEditPointExpiration">
              <v-layout
                justify-space-around
                align-content-center
                align-center
                row
                wrap
                class="pa-0 ma-0"
              >
                <v-flex xs12 sm5 class="form-control">{{
                  points_expiration | DateFormat('วันที่ DD/MM/YYYY')
                }}</v-flex>
                <v-flex xs12 sm5 class="form-control">{{
                  points_expiration_next | DateFormat('วันที่ DD/MM/YYYY')
                }}</v-flex>
              </v-layout>
            </div>
            <div v-else>
              <v-layout
                justify-space-around
                align-content-center
                align-center
                row
                wrap
                class="pa-0 ma-0"
              >
                <v-flex xs12 sm5 class="form-control">
                  <DatepickerCustomDialog
                    v-model="input.pointexpiredate"
                    :disabled="yearformated - 1 <= thisYear"
                  >
                    <input
                      type="text"
                      readonly
                      :value="dateformated"
                      :class="`${yearformated - 1 <= thisYear ? 'bg-gray' : ''}`"
                    />
                  </DatepickerCustomDialog>
                </v-flex>
                <v-flex xs12 sm5 class="form-control">
                  <DatepickerCustomDialog
                    v-model="input.pointexpiredatenext"
                    :disabled="yearformatednext - 1 <= thisYear"
                  >
                    <input
                      type="text"
                      readonly
                      :value="dateformatednext"
                      :class="`${yearformatednext - 1 <= thisYear ? 'bg-gray' : ''}`"
                    />
                  </DatepickerCustomDialog>
                </v-flex>
              </v-layout>
              <div class="text-xs-center">
                <v-btn :disabled="expireloading" outline color="grey" @click="cancelExpPoint"
                  >Cancel</v-btn
                ><v-btn :loading="expireloading" depressed color="primary" @click="saveExpPoint"
                  >Save</v-btn
                >
              </div>
            </div>
          </v-flex>
          <v-flex xs2 class="text-xs-right">
            <v-btn v-if="!isEditPointExpiration" icon @click="editPointExp">
              <v-icon>edit</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </div>
      <v-divider></v-divider>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import DatepickerCustomDialog from '@/components/elements/DatepickerCustomDialog.vue'
import CustomTimepicker from '@/components/elements/CustomTimepicker.vue'
import api from '@/api'
import { mapGetters } from 'vuex'
import { ToggleButton } from 'vue-js-toggle-button'
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'
export default {
  components: {
    DatepickerCustomDialog,
    CustomTimepicker,
    ScaleLoader,
    ToggleButton
  },
  data() {
    return {
      input: {
        welcome_points: '',
        purchase_amount: '',
        pointexpiredate: '',
        pointexpiredatenext: '',
        slipUploadExpireDate: '',
        slipUploadExpireDateNext: ''
      },
      welcome_points: 0,
      purchase_amount: 0,
      points_expiration: '1995-12-08 13:30',
      points_expiration_next: '1995-12-08 13:30',
      slip_upload_expiration: '1995-12-08 13:30',
      slip_upload_expiration_next: '1995-12-08 13:30',
      welcomepointloading: false,
      purchase_amountloading: false,
      expireloading: false,
      isEditWelcomePoint: false,
      isEditDividePoint: false,
      isEditPointExpiration: false,
      isEditSlipUploadExpiration: false,
      loading: true,
      welcome_points_status: false,
      welcomepointstatus_loading: false
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    dateformated() {
      if (this.input.pointexpiredate) {
        return moment(this.input.pointexpiredate).format('DD/MM/YYYY')
      } else {
        return ''
      }
    },
    dateformatednext() {
      if (this.input.pointexpiredatenext) {
        return moment(this.input.pointexpiredatenext).format('DD/MM/YYYY')
      } else {
        return ''
      }
    },
    slipDateFormated() {
      return this.input.slipUploadExpireDate
        ? moment(this.input.slipUploadExpireDate).format('DD/MM/YYYY')
        : ''
    },
    slipDateFormatedNext() {
      return this.input.slipUploadExpireDateNext
        ? moment(this.input.slipUploadExpireDateNext).format('DD/MM/YYYY')
        : ''
    },
    yearformated() {
      if (this.input.pointexpiredate) {
        return moment(this.input.pointexpiredate).format('YYYY')
      } else {
        return ''
      }
    },
    yearformatednext() {
      if (this.input.pointexpiredatenext) {
        return moment(this.input.pointexpiredatenext).format('YYYY')
      } else {
        return ''
      }
    },
    thisYear() {
      let date = new Date()
      return moment(date).format('YYYY')
    }
  },
  mounted() {
    this.getPointData()
  },
  methods: {
    getPointData() {
      return new Promise((resolve) => {
        var data = {
          pageid: this.selectedBot.pageid
        }
        this.loading = true
        api.getpointdatatoacrm(data, (err, response) => {
          this.loading = false
          if (response.responsecode == 200) {
            this.welcome_points = response.data[0].welcome_points
            this.purchase_amount = response.data[0].purchase_amount
            this.points_expiration = response.data[0].points_expiration
            this.points_expiration_next = response.data[0].points_expiration_next
            this.welcome_points_status = response.data[0].welcome_points_status
            this.slip_upload_expiration = response.data[0].slip_upload_expiration
            this.slip_upload_expiration_next = response.data[0].slip_upload_expiration_next
          }
        })
        resolve()
      })
    },
    editPointExp() {
      if (this.points_expiration) {
        // var datetime = this.points_expiration.split(' ')
        this.input.pointexpiredate = this.points_expiration
      }
      if (this.points_expiration_next) {
        // var datetime = this.points_expiration_next.split(' ')
        this.input.pointexpiredatenext = this.points_expiration_next
      }
      this.isEditPointExpiration = true
    },
    editSlipUploadExp() {
      if (this.slip_upload_expiration) {
        this.input.slipUploadExpireDate = this.slip_upload_expiration
      }
      if (this.slip_upload_expiration_next) {
        this.input.slipUploadExpireDateNext = this.slip_upload_expiration_next
      }
      this.isEditSlipUploadExpiration = true
    },
    setWelcomPointStatus() {
      this.welcomepointstatus_loading = true
      var data = {
        pageid: this.selectedBot.pageid,
        welcome_points_status: !this.welcome_points_status // boolean
      }
      api.setwelcomepointStatusToacrm(data, (err, response) => {
        this.welcomepointstatus_loading = false
        if (response.responsecode == 200) {
          this.welcome_points_status = !this.welcome_points_status
        }
      })
    },
    saveExpPoint() {
      this.expireloading = true
      var result = this.input.pointexpiredate
      var result2 = this.input.pointexpiredatenext
      var data = {
        pageid: this.selectedBot.pageid,
        points_expiration: result,
        points_expiration_next: result2
      }
      api.setexpirepointtoacrm(data, (err, response) => {
        this.expireloading = false
        this.points_expiration = result
        this.points_expiration_next = result2
        this.isEditPointExpiration = false
      })
    },
    saveSlipUploadExp() {
      this.expireloading = true
      const setSlipUploadExpire = this.input.slipUploadExpireDate
      const setSlipUploadExpireNext = this.input.slipUploadExpireDateNext
      const data = {
        pageid: this.selectedBot.pageid,
        slip_upload_expiration: setSlipUploadExpire,
        slip_upload_expiration_next: setSlipUploadExpireNext
      }
      api.setSlipUploadExpireToacrm(data, (err, response) => {
        this.expireloading = false
        this.slip_upload_expiration = setSlipUploadExpire
        this.slip_upload_expiration_next = setSlipUploadExpireNext
        this.isEditSlipUploadExpiration = false
      })
    },
    cancelExpPoint() {
      this.isEditPointExpiration = false
    },
    cancelExpSlipUpload() {
      this.isEditSlipUploadExpiration = false
    },
    saveWelcomePoint() {
      this.welcomepointloading = true
      var data = {
        pageid: this.selectedBot.pageid,
        welcome_points: this.input.welcome_points
      }
      api.setwelcomepointtoacrm(data, (err, response) => {
        this.welcomepointloading = false
        this.welcome_points = this.input.welcome_points
        this.input.welcome_points = ''
        this.isEditWelcomePoint = false
      })
    },
    saveDividePoint() {
      var data = {
        pageid: this.selectedBot.pageid,
        purchase_amount: this.input.purchase_amount
      }
      this.purchase_amountloading = true
      api.setpurchasepointtoacrm(data, (err, response) => {
        this.purchase_amountloading = false
        this.purchase_amount = this.input.purchase_amount
        this.input.purchase_amount = ''
        this.isEditDividePoint = false
      })
    },
    cancelWelcomePoint() {
      this.isEditWelcomePoint = false
    },
    cancelDividePoint() {
      this.isEditDividePoint = false
    }
  }
}
</script>

<style lang="scss" scoped>
.bg-gray {
  background-color: #eee !important;
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/toacrm/Point.vue